<template>
  <div>
    <div id="svgDiv" style="height: 30vh;width: 100%;overflow-y: scroll;overflow-x: hidden">
      <svg class="canvas" id="svg-canvas" preserveAspectRatio="xMidYMax meet" viewBox="0 0  1200  1200  ">
      </svg>
    </div>
    <svg class="xaxis" id="svg-xaxis" viewBox="0 0  1200  40  ">

    </svg>
    <div id="dragSvg" ref="myDiv" style="height: 40vh;width: 100%;overflow-y: scroll;overflow-x: hidden;margin-top: 5vh;margin-left: 0.01rem">
      <!--      <svg v-for="(item, index) in activePaths" :id="'axisSvg' + index" :key="'axisSvg' + index">-->

      <!--      </svg>-->
    </div>
  </div>
</template>

<script>
import * as d3 from 'd3'
import dagreD3 from 'dagre-d3'
export default {
  name: 'TaskNodeTimeLine',
  data() {
    return {
      dragNode: '',
      dragNodeArr: [],
      dragNodeMap: new Map(),
      dragScaleMap: new Map(),
      currentScale: '',
      activeNode: '',
      activeNodeArr: [],
      activeHeadNodeArr: [],
      activePaths: [],
      nodeInfo: [
        {
          id: 'n0',
          label: '开始',
          status: 'today',
          from: [],
          to: [],
          startDate: 1575129600000,
          date: 1575216000000
        }, {
          id: 'n1',
          label: '流程节点',
          status: 'flow',
          from: [],
          to: [],
          startDate: 1578067200000,
          date: 1578376890000
        }, {
          id: 'n2',
          label: '流程节点',
          status: 'flow',
          from: [],
          to: [],
          startDate: 1578067200000,
          date: 1578376890000
        }, {
          id: 'n3',
          label: '流程节点',
          status: 'flow',
          from: [],
          to: [],
          startDate: 1578376890000,
          date: 1578895290000
        }, {
          id: 'n4',
          label: '',
          status: 'flow',
          from: [],
          to: [],
          startDate: 1578885290000,
          date: 1578895290000
        }, {
          id: 'n5',
          label: '',
          status: 'flow',
          from: [],
          to: [],
          startDate: 1578885290000,
          date: 1579327290000
        }, {
          id: 'n6',
          label: '',
          status: 'flow',
          from: [],
          to: [],
          startDate: 1578885290000,
          date: 1579932090000
        }, {
          id: 'n7',
          label: '',
          status: 'flow',
          from: [],
          to: [],
          startDate: 1578885290000,
          date: 1581487290000
        }, {
          id: 'n8',
          label: '',
          status: 'end',
          from: [],
          to: [],
          startDate: 1578885290000,
          date: 1581487290000
        }
      ],
      lineInfo: [
        { from: 'n0', to: 'n1' },
        { from: 'n0', to: 'n2' },
        { from: 'n0', to: 'n3' },
        { from: 'n2', to: 'n4' },
        { from: 'n2', to: 'n5' },
        { from: 'n3', to: 'n6' },
        { from: 'n6', to: 'n7' },
        { from: 'n6', to: 'n8' }
      ],
      nodeMap: new Map(),
      nodeDomMap: new Map(),
      timeArr: [],
      width: 1200,
      height: 1200,
      padding: { top: 0, bottom: 40, left: 40, right: 40 },
      min: '',
      max: '',
      maxY: '',
      maxM: '',
      minY: '',
      minM: ''
    }
  },
  mounted() {
    this.initData()
    this.addElement()
    console.log('d3.event.x', this.$refs.myDiv)
  },
  methods: {
    initData() {
      // 节点信息转化为map
      this.nodeInfo.forEach(item => {
        this.nodeMap.set(item.id, item)
        this.timeArr.push(item.date)
      })
      this.lineInfo.forEach(item => {
        this.nodeMap.get(item.from).to.push(item.to)
        this.nodeMap.get(item.to).from.push(item.from)
      })
      console.log('节点集合', this.nodeMap)
      this.max = new Date(d3.max(this.timeArr))
      this.min = new Date(d3.min(this.timeArr))
      this.maxY = this.max.getFullYear()
      this.maxM = this.max.getMonth()
      this.minY = this.min.getFullYear()
      this.minM = this.min.getMonth()
    },
    addElement() {
      const self = this
      const svg = d3.select('#svg-canvas')
      const svg1 = d3.select('#svg-xaxis')
      // 初始化元素
      const background = svg.append('rect').attr('class', 'bg')
      const view = svg.append('g').attr('class', 'view')
      const grid = svg.append('g').attr('class', 'grid')
      const axis = svg1.append('g').attr('class', 'axis')
      // const separateLine = svg.append('line').attr('class', 'separate-line')

      // 绘制箭头以供引用
      d3.select('#svg-canvas').append('defs').append('marker')
        .attr('id', 'triangle').attr('viewBox', '0 0 10 10')
        .attr('refX', '17').attr('refY', '5')
        .attr('markerWidth', '6').attr('markerHeight', '6')
        .attr('orient', 'auto').append('path')
        .attr('d', 'M 0 0 L 10 5 L 0 10 z').style('fill', '#bbbbbb')

      // 添加背景板 rect
      background.attr('fill', '#FAFAFA')
        .attr('x', 0).attr('y', 0)
        .attr('width', this.width).attr('height', this.height)
      const monthNum = d3.timeMonth.count(this.min, this.max) // 区间月份数量
      // 确定比例尺
      const xScale = d3.scaleTime()
        .domain([new Date(this.minY, this.minM, 1), new Date(this.maxY, ++this.maxM, 1)])
        .range([0, this.width - this.padding.left - this.padding.right])
      self.currentScale = xScale

      // 坐标轴文本格式化
      const formatDay = d3.axisBottom(xScale).tickFormat((d, i) => {
        const date = new Date(d)
        const day = date.getDate()
        return `${day === 1 ? '' : day}` // 如果是1号, 不显示刻度,直接由xAxis2显示年月
      })
      const formatMonth = d3.axisBottom(xScale).ticks(d3.timeMonth.every(1)).tickPadding(6).tickSizeInner(20).tickFormat((d, i) => {
        const date = new Date(d)
        const mon = date.getMonth() + 1
        const year = date.getFullYear()
        return `${year} - ${mon > 9 ? mon : '0' + mon}`
      })
      // axis.attr('transform', `translate(${this.padding.left},${this.height - this.padding.bottom})`)
      const xAxisDay = axis.append('g')
        .attr('class', 'x-axis').call(formatDay)
      const xAxisMonth = axis.append('g')
        .attr('class', 'x2-axis').call(formatMonth)

      // 绘制x网格
      const lineGroup = grid.attr('transform', `translate(${this.padding.left},0)`)
        .selectAll('g')
        .data(xScale.ticks(monthNum))
        .enter().append('g')
      lineGroup.append('line')
        .attr('x1', d => { return xScale(new Date(d)) })
        .attr('x2', d => { return xScale(new Date(d)) })
        .attr('y1', this.padding.top)
        .attr('y2', this.height - this.padding.bottom)
        .attr('class', 'grid-line')
        .style('stroke', '#DCDCDC')
        .style('stroke-dasharray', 6)
        // 添加坐标轴与拓扑图分隔线
        // separateLine.style('stroke', '#DCDCDC')
        //   .style('stroke-width', 2)
        //   .attr('x1', 0)
        //   .attr('x2', this.width)
        //   .attr('y1', this.height - this.padding.bottom)
        //   .attr('y2', this.height - this.padding.bottom)

      // 绘制流程图 节点--箭头
      const g = new dagreD3.graphlib.Graph()
        .setGraph({
          edgesep: 1
        })
        .setDefaultEdgeLabel(function() { return {} })
      g.graph().rankdir = 'LR' // 控制水平显示
      g.graph().nodesep = '1' // 控制水平显示
      // g.graph().edgesep = '1' // 控制水平显示
      g.graph().marginx = 0
      g.graph().marginy = 0
      // { labelType: "html", label: `<i class="${item.type} ${item.isFinished ? "finished" : "unfinished"}"><b>${item.label}</b></i>` }
      this.nodeInfo && this.nodeInfo.map((item, i) => {
        g.setNode(item.id, {
          labelType: 'html',
          labelStyle: 'font-weight:bold',
          label: `<i class="service"><b>${item.label}</b></i>`,
          class: 'type-' + item.status,
          style: 'stroke-width: 2px; stroke: #fff',
          shape: 'circle',
          id: item.id
        })

      })
      this.lineInfo && this.lineInfo.map((item, i) => {
        g.setEdge(item.from, item.to,
          {
            arrowheadStyle: 'stroke:none; fill: none', // 箭头头部样式
            style: 'stroke:none; fill: none' //线条样式
          })

      })
      // eslint-disable-next-line
        const render = new dagreD3.render()
      render(view.attr('transform', `translate(${this.padding.left},0)`), g)

      let maxY = 0
      // 重新定位节点x坐标
      const nodesArr = d3.select('.nodes').selectAll('.node')._groups[0]
      nodesArr.forEach((item) => {
        const dom = d3.select(item)._groups[0][0]
        // const id = Number(dom.id)
        const id = dom.id
        const date = this.nodeMap.get(id).date
        const x = xScale(new Date(date))
        const y = dom.transform.animVal[0].matrix.f

        if (y > maxY) {
          maxY = y
        }
        d3.select(item).attr('transform', `translate(${x},${y})`)
        this.nodeDomMap.set(item.id, item)
      })

      // 重新绘制箭头
      this.lineInfo && this.lineInfo.map((item, i) => {
        const fromDom = this.nodeDomMap.get(item.from)
        const toDom = this.nodeDomMap.get(item.to)
        const [x1, y1, x2, y2] = [
          fromDom.transform.animVal[0].matrix.e,
          fromDom.transform.animVal[0].matrix.f,
          toDom.transform.animVal[0].matrix.e,
          toDom.transform.animVal[0].matrix.f
        ]
        d3.select('.edgePaths').append('g')
          .append('line')
          .attr('id', 'edgeLine')
          .attr('class', `path-${item.from}-${item.to}`) // 设置唯一的class方便修改路径
          .attr('stroke-width', '2')
          .attr('stroke', '#bbbbbb')
          .attr('marker-end', 'url(#triangle)')
          .attr('x1', x1).attr('y1', y1)
          .attr('x2', x2).attr('y2', y2)

      })
      //点击空白
      d3.select('.edgePaths').append('g')
        .append('rect')
        .attr('id', 'noColorRect')
        .attr('x', 0)
        .attr('y', 0)
        .attr('fill', 'transparent')
        .attr('width', this.width)
        .attr('height', this.height - this.padding.bottom)

      d3.selectAll('circle.label-container').attr('r', 10)
      // 设置zoom参数
      const zoom = d3.zoom()
        .scaleExtent([0.5, 10])
        .translateExtent([[0, 0], [this.width, this.height]]) //移动的范围
        .extent([[0, 0], [this.width, this.height]])//视窗 （左上方，右下方）

      svg.call(zoom.on('zoom', reRender.bind(this)))


      d3.selectAll('.label').attr('transform', 'translate(0,20)')

      //添加节点点击事件
      d3.select('.nodes').selectAll('.node').on('mousedown', e => {
        d3.select('.nodes').selectAll('.node').classed('unActiveNode', true)
        // 先获取所有的线段,并将这些线段都设置透明度为0.2
        d3.select('.edgePaths').selectAll('#edgeLine')
          .attr('style', 'opacity:0.2')
          .classed('active', false)
          // 当前的节点名字为e,将所有与e有关的线段添加类名active,进行高亮显示
        self.activeNode = e
        self.activeNodeArr = []
        self.activeHeadNodeArr = []
        self.makeF_Active(e)
        self.makeE_Active(e)
        setTimeout(function() {
          self.makePaths()
          self.addDragSvg()
        }, 500)
      })

      //添加非节点区域点击事件
      d3.select('#noColorRect').on('click', e => {
        d3.select('.edgePaths').selectAll('#edgeLine')
          .attr('style', 'opacity:1')
          .classed('active', false)

        d3.select('.nodes').selectAll('.node').classed('activeNode', false)
        d3.select('.nodes').selectAll('.node').classed('unActiveNode', false)
        self.activeNodeArr = []
        self.activeHeadNodeArr = []
        self.deleteDragSvg()
      })


      const tooltip = d3.select('#svgDiv').append('div').classed('tooltip', true).style('opacity', 0).style('display', 'none')
      //tooltip显示
      function tipVisible(textContent) {
        tooltip.transition()
          .duration(400)
          .style('opacity', 0.6)
          .style('display', 'block')
        tooltip.html(textContent)
          .style('left', (d3.event.pageX + 15) + 'px')
          .style('top', (d3.event.pageY - 40) + 'px')
      }
      //tooltip隐藏
      function tipHidden() {
        tooltip.transition()
          .duration(400)
          .style('opacity', 0)
          .style('display', 'none')
      }

      //鼠标悬停显示隐藏tooltip
      d3.select('.nodes').selectAll('.node')
        .on('mouseover', function(v) {
          const startDate = self.formatterDate(self.nodeMap.get(v).startDate)
          const finishDate = self.formatterDate(self.nodeMap.get(v).date)
          tipVisible('计划开始时间:' + startDate + '<br/>' + '计划完成时间:' + finishDate)
        })
        .on('mouseout', function(v) {
          tipHidden()
        })

      // 每次缩放重定位渲染拓扑图
      function reRender() {
        // console.log('d3.event.transform', d3.event.transform.y)
        // view.attr('transform', `translate(0, ${d3.event.transform.y})`)
        const t = d3.event.transform.rescaleX(xScale) //获得缩放后的比例尺
        // self.reRenderGraph(t)
        xAxisDay.call(formatDay.scale(t)) //重新设置x坐标轴的scale
        xAxisMonth.call(formatMonth.scale(t)) //重新设置x坐标轴的scale

        // const view = d3.select('.output')
        // const axis = d3.select('.axis-month')
        // const grid = d3.selectAll('.grid-line')

        // 重新绘制节点
        nodesArr.forEach((item) => {
          const dom = d3.select(item)._groups[0][0]
          const id = dom.id
          const date = this.nodeMap.get(id).date
          const x = t(new Date(date))
          const y = dom.transform.animVal[0].matrix.f
          d3.select(item).attr('transform', `translate(${x},${y})`)
          this.nodeDomMap.set(item.id, item)
        })


        // 重新绘制箭头
        this.lineInfo && this.lineInfo.map((item, i) => {
          const fromDom = this.nodeDomMap.get(item.from)
          const toDom = this.nodeDomMap.get(item.to)
          const [x1, y1, x2, y2] = [
            fromDom.transform.animVal[0].matrix.e,
            fromDom.transform.animVal[0].matrix.f,
            toDom.transform.animVal[0].matrix.e,
            toDom.transform.animVal[0].matrix.f
          ]
          d3.select(`.path-${item.from}-${item.to}`)
            .attr('x1', x1).attr('y1', y1)
            .attr('x2', x2).attr('y2', y2)

        })

        //重新绘制x网格
        svg.selectAll('.grid-line')
          .attr('x1', d => { return t(new Date(d)) })
          .attr('x2', d => { return t(new Date(d)) })
      }
    },
    deleteDragSvg() {
      d3.select('#dragSvg').selectAll('svg').remove()
      this.dragScaleMap.clear()
    },
    addDragSvg() {
      this.deleteDragSvg()
      // this.dragNodeMap.clear()
      if (this.activePaths.length > 0) {
        this.activePaths.forEach((item, index) => {
          this.addDragXaxis(index, item)
        })

      } else {
        d3.select('#dragSvg').selectAll('svg').remove()
      }
    },
    /**
       * 添加可拖拽x轴
       */
    addDragXaxis(index, pathArr) {
      const self = this
      const timeArr = []
      const startTimeArr = []
      // this.dragNodeMap.clear()
      pathArr.forEach(item => {
        self.dragNodeMap.set(item.id, item)
        timeArr.push(item.date)
        startTimeArr.push(item.startDate)
      })
      const max = new Date(d3.max(timeArr))
      const min = new Date(d3.min(startTimeArr))
      const maxY = max.getFullYear()
      let maxM = max.getMonth()
      const minY = min.getFullYear()
      const minM = min.getMonth()

      //添加坐标轴
      const svg = d3.select('#dragSvg').append('svg')
        .attr('id', 'axisSvg' + index)
        .style('width', '100%')
        .style('height', '8vh')
      // .attr('viewBox', '0 0 1200 80')
        .attr('class', 'xaxis')
      const axis = svg.append('g').attr('class', 'axis')
      // 确定比例尺
      const xScale = d3.scaleTime()
        .domain([new Date(new Date(minY, minM, 1).getTime() - 5 * 24 * 60 * 60 * 1000), new Date(maxY, ++maxM, 1)])
      // .range([0, this.width - this.padding.left - this.padding.right])
        .range([0, self.$refs.myDiv.scrollWidth])
      this.dragScaleMap.set(index, xScale)
      // 坐标轴文本格式化
      const formatDay = d3.axisBottom(xScale).tickFormat((d, i) => {
        const date = new Date(d)
        const day = date.getDate()
        return `${day === 1 ? '' : day}` // 如果是1号, 不显示刻度,直接由xAxis2显示年月
      })
      const formatMonth = d3.axisBottom(xScale).ticks(d3.timeMonth.every(1)).tickPadding(6).tickSizeInner(20).tickFormat((d, i) => {
        const date = new Date(d)
        const mon = date.getMonth() + 1
        const year = date.getFullYear()
        return `${year} - ${mon > 9 ? mon : '0' + mon}`
      })
      // axis.attr('transform', `translate(${this.padding.left}, 40)`)

      axis.attr('transform', `translate(0, 40)`)
      //日期时间轴
      const xAxisDay = axis.append('g')
        .attr('class', 'x-axis').call(formatDay)
        //月份时间轴
      const xAxisMonth = axis.append('g')
        .attr('class', 'x2-axis').call(formatMonth)
        //坐标轴分割线
      const separateLine = svg.append('line').attr('class', 'separate-line')

      // 添加坐标轴分隔线
      separateLine.style('stroke', '#DCDCDC')
        .style('stroke-width', 2)
        .attr('x1', 0)
        .attr('x2', this.width)
        .attr('y1', 40)
        .attr('y2', 40)

      //添加节点组
      const circleNodeGroup = svg.append('g').attr('class', 'circle_node_group')
      //添加时间label
      svg.append('g').attr('class', 'timeLabelGroup')
      svg.append('g').attr('class', 'nameLabelGroup')
      //添加节点连线组
      svg.append('g').attr('class', 'circle_node_polyline')

      pathArr.forEach(item => {
        const key = item.id
        const value = self.dragNodeMap.get(key)
        //画节点
        self.drawDragNode(index, svg, circleNodeGroup, xScale, value, key)
      })



      // 设置zoom参数
      const zoom = d3.zoom()
        .scaleExtent([0.5, 5])
        .translateExtent([[0, 40], [self.$refs.myDiv.scrollWidth, 40]]) //移动的范围
        .extent([[0, 40], [self.$refs.myDiv.scrollWidth, 40]])//视窗 （左上方，右下方）

      svg.call(zoom.on('zoom', reRender.bind(this)))
      // 每次缩放重定位渲染拓扑图
      function reRender() {
        const t = d3.event.transform.rescaleX(xScale) //获得缩放后的比例尺
        this.dragScaleMap.set(index, t)
        xAxisDay.call(formatDay.scale(t)) //重新设置x坐标轴的scale
        xAxisMonth.call(formatMonth.scale(t)) //重新设置x坐标轴的scale

        // 重新绘制节点
        pathArr.forEach(item => {
          const key = item.id
          const value = self.dragNodeMap.get(key)
          //画节点
          self.drawDragNode(index, svg, circleNodeGroup, t, value, key)
        })



      }
    },
    /**
       * 画拖拽时间轴上的线段
       * @param svg 当前画布
       * @param id 当前节点id
       */
    drawNodeLine(svg, id) {
      const circleNodePolyline = svg.select('.circle_node_polyline')
      circleNodePolyline.select('#polyline-' + id).remove()
      const startNode = svg.select('#start-' + id)
      const endNode = svg.select('#end-' + id)
      const x0 = startNode.attr('cx')
      const y0 = startNode.attr('cy')
      const x1 = endNode.attr('cx')
      const y1 = endNode.attr('cy')
      circleNodePolyline.append('polyline')
        .attr('id', 'polyline-' + id)
        .attr('points', `${x0},${y0} ${x0},${y0 - 20} ${x1},${y1 - 20} ${x1},${y1}`)
        .style('stroke', '#0c0c0c')
        .style('stroke-width', 2)
        .style('fill', 'none')
    },
    /**
       * 格式化时间 格式：2021-12-18
       * d long型时间
       */
    formatterDate(d) {
      const date = new Date(d)
      const day = date.getDate()
      const mon = date.getMonth() + 1
      const year = date.getFullYear()
      return `${year}-${mon > 9 ? mon : '0' + mon}-${day > 9 ? day : '0' + day}`
    },
    /**
       * 格式化时间 格式：2021-12-18
       * date 国际时间
       */
    formatterDateFunc(date) {
      const day = date.getDate()
      const mon = date.getMonth() + 1
      const year = date.getFullYear()
      return `${year}-${mon > 9 ? mon : '0' + mon}-${day > 9 ? day : '0' + day}`
    },
    /**
       * 递归激活当前节点的前置节点
       * @param e 当前节点id
       * @author Hanger Zou
       */
    makeF_Active(e) {
      const that = this
      this.activeNodeArr.push(e)
      d3.select(`#${e}`).classed('unActiveNode', false)
      d3.select(`#${e}`).classed('activeNode', true)
      if (this.nodeMap.get(e).from.length > 0) {
        this.nodeMap.get(e).from.forEach(item => {
          d3.select(`.path-${item}-${e}`).classed('active', true)
          that.makeF_Active(item)
        })
      } else {
        this.activeHeadNodeArr.push(e)
        return
      }

    },
    /**
       * 递归激活当前节点的后置节点
       * @param e 当前节点id
       * @author Hanger Zou
       */
    makeE_Active(e) {
      const that = this
      this.activeNodeArr.push(e)
      d3.select(`#${e}`).classed('unActiveNode', false)
      d3.select(`#${e}`).classed('activeNode', true)
      if (this.nodeMap.get(e).to.length > 0) {
        this.nodeMap.get(e).to.forEach(item => {
          d3.select(`.path-${e}-${item}`).classed('active', true)
          that.makeE_Active(item)
        })
      } else {
        return
      }

    },
    /**
       * 将选中节点转换成多条路径
       * @returns {[]}
       */
    makePaths() {
      const that = this
      this.activePaths = []
      if (this.activeNodeArr.length === 0 || this.activeHeadNodeArr.length === 0) {
        this.activePaths = []
      } else {
        this.activeHeadNodeArr.forEach(item => {
          const head = that.nodeMap.get(item)
          const nodeListRow = []
          nodeListRow.push(head)
          if (head.to === undefined || head.to.length === 0) {
            that.activePaths.push(nodeListRow)
          } else {
            that.forEachChild(head.to, nodeListRow)
          }
        })
      }
      return this.activePaths
    },
    /**
       * 递归遍历选中节点生成多路线
       * @param to 当前节点
       * @param nodeListRow 当前行
       */
    forEachChild(to, nodeListRow) {
      const that = this
      if (to.length > 0) {
        to.forEach(item => {
          const goOnList = that.deepCopy(nodeListRow)
          if (that.activeNodeArr.includes(item)) {
            const node = that.nodeMap.get(item)
            goOnList.push(node)
            if (node.to === undefined || node.to.length === 0) {
              that.activePaths.push(goOnList)
            } else {
              this.forEachChild(node.to, goOnList)
            }
          }
        })
      }
    },
    /**
       * 深拷贝数组、对象
       * @param obj
       * @returns {[]|{}}
       */
    deepCopy(obj) {
      const newObj = obj.constructor === Array ? [] : {} //判断是深拷贝对象还是数组
      for (const i in obj) {
        if (typeof obj[i] === 'object') {
          newObj[i] = Object.assign({}, obj[i])//  如果要拷贝的对象的属性依然是个复合类型，递归
        } else {
          newObj[i] = obj[i]
        }
      }
      return newObj
    },
    /**
       * 画可拖拽的节点
       * @param svg 当前画布
       * @param circleNodeGroup 节点组
       * @param xScale 比例函数
       * @param node 节点对象
       * @param id 节点id
       * @author Hanger Zou
       */
    drawDragNode(index, svg, circleNodeGroup, xScale, node, id) {
      const self = this
      let nodeX = 0
      let nodeClientX = 0
      // let offsetX = self.$refs.myDiv.offsetLeft
      let nodeDate = new Date()
      //重算比率 用于世界坐标轴与比例坐标轴换算
      console.log('x0', xScale.invert(0))
      console.log('x1200', xScale.invert(1200))
      console.log('self.$refs.myDiv.offsetWidth', self.$refs.myDiv)
      const minTime = xScale.invert(0).getTime()
      const maxTime = xScale.invert(1200).getTime()
      const timeNum = maxTime - minTime
      // const dayNum = d3.timeDay.count(xScale.invert(0), xScale.invert(1200))
      // const unit = dayNum / self.$refs.myDiv.offsetWidth
      const unit = timeNum / self.$refs.myDiv.scrollWidth
      const unit1 = 1200 / self.$refs.myDiv.scrollWidth
      console.log('123', unit1)
      //定义拖拽
      const nodeDrag = d3.drag()
        .on('start', nodeDragStart) // 拖动开始，触发一次
        .on('drag', nodeDraging) // 拖动中，触发多次
        .on('end', nodeDragEnd) // 拖动结束，触发一次
        //拖拽开始
      function nodeDragStart() {
        nodeX = d3.select(this).attr('cx')
        nodeClientX = d3.event.x
        nodeDate = xScale.invert(nodeX)
        // self.drawTimeLabel(svg, 'startText' + key, nodeX, xScale)
      }
      //拖拽中
      function nodeDraging() {
        let type = 'start-'
        if (!d3.select(this).attr('id').startsWith(type)) {
          type = 'end-'
        }
        // const time = nodeDate.getTime() + (Math.round((d3.event.x - nodeClientX) * unit) * 24 * 60 * 60 * 1000)
        // const time = nodeDate.getTime() + ((d3.event.x - nodeClientX) * unit * 24 * 60 * 60 * 1000)
        const time = nodeDate.getTime() + ((d3.event.x - nodeClientX) * unit)
        const newXs = parseInt(nodeX) + ((d3.event.x - nodeClientX) * unit1)
        console.log('newXs', newXs)
        console.log('nodeX', typeof nodeX)
        console.log('nodeXqq', typeof ((d3.event.x - nodeClientX) * unit1))
        d3.select(this).attr('cx', newXs + '')
        self.drawTimeLabel(svg, type + 'text-' + id, xScale(new Date(time)), new Date(time))
        self.drawNodeLine(svg, d3.select(this).attr('id').slice(type.length))
        self.drawNameLabel(svg, d3.select(this).attr('id').slice(type.length))
        self.dragScaleMap.forEach((value, key) => {
          //非当前路径
          if (key !== index) {
            let flag = false
            self.activePaths[key].forEach(item => {
              if (item.id === id) {
                flag = true
              }
            })
            if (flag) {
              //同步画节点
              const otherSvg = d3.select('#axisSvg' + key)
              const otherCircleNodeGroup = otherSvg.select('.circle_node_group')
              const newNode = self.deepCopy(node)
              if (type === 'start-') {
                newNode.startDate = time
              } else {
                newNode.date = time
              }
              //同步绘制其他轴
              self.drawDragNode(key, otherSvg, otherCircleNodeGroup, value, newNode, id)
            }

          }

        })

      }
      //拖拽结束
      function nodeDragEnd() {
        let type = 'start-'
        let tailTime = ' 00:00:00'
        if (!d3.select(this).attr('id').startsWith(type)) {
          type = 'end-'
          tailTime = ' 23:59:59'
        }
        // let time = nodeDate.getTime() + ((d3.event.x - nodeClientX) * unit) * 24 * 60 * 60 * 1000
        let time = nodeDate.getTime() + ((d3.event.x - nodeClientX) * unit)
        const str = self.formatterDate(time)
        time = Date.parse(str + tailTime)
        d3.select(this).attr('cx', xScale(new Date(time)))
        if (type === 'start-') {
          self.dragNodeMap.get(id).startDate = time
        } else {
          self.dragNodeMap.get(id).date = time
        }
        self.removeDrawTimeLabel(svg, type + 'text-' + id)
        self.drawNodeLine(svg, d3.select(this).attr('id').slice(type.length))
        self.drawNameLabel(svg, d3.select(this).attr('id').slice(type.length))
      }

      //重绘时清除该节点
      circleNodeGroup.select('#start-' + id).remove()
      circleNodeGroup.select('#end-' + id).remove()
      const startDate = node.startDate
      const date = node.date
      //比例换算节点x轴位置
      const x = xScale(new Date(startDate))
      const xfininsh = xScale(new Date(date))
      //画开始节点
      circleNodeGroup.append('circle')
        .attr('id', 'start-' + id)
        .attr('class', 'startNode')
        .attr('r', 4)
        .attr('cx', x)
        .attr('cy', 40)
        .call(nodeDrag)
        .on('mouseover', () => {
          const nowX = svg.select('#start-' + id).attr('cx')
          self.drawTimeLabel(svg, 'start-text-' + id, nowX, xScale.invert(nowX))
        })
        .on('mouseout', () => {
          self.removeDrawTimeLabel(svg, 'start-text-' + id)
        })


      //画结束节点
      circleNodeGroup.append('circle')
        .attr('id', 'end-' + id)
        .attr('class', 'endNode')
        .attr('r', 6)
        .attr('cx', xfininsh)
        .attr('cy', 40)
        .call(nodeDrag)
        .on('mouseover', () => {
          const nowX = svg.select('#end-' + id).attr('cx')
          console.log('nowX', nowX)
          console.log('d3', d3.event.x)
          self.drawTimeLabel(svg, 'end-text-' + id, nowX, xScale.invert(nowX))
        })
        .on('mouseout', () => {
          self.removeDrawTimeLabel(svg, 'end-text-' + id)
        })



      //画连线
      this.drawNodeLine(svg, id)
      this.drawNameLabel(svg, id)

    },
    /**
       * 删除时间标签
       * @param svg 当前画布
       * @param textId 标签id
       * @author Hanger Zou
       */
    removeDrawTimeLabel(svg, textId) {
      svg.select('#' + textId).remove()
    },
    /**
       * 生成时间标签
       * @param svg 当前画布
       * @param textId 标签id
       * @param x x轴坐标
       * @param dateLong 时间 long型
       * @author Hanger Zou
       */
    drawTimeLabel(svg, textId, x, dateLong) {
      let color = '#E8684A'
      if (textId.startsWith('start')) {
        color = '#9270CA'
      }
      svg.select('#' + textId).remove()
      const timeLabelGroup = svg.select('.timeLabelGroup')
      timeLabelGroup.append('text')
        .text(this.formatterDate(dateLong))
        .attr('id', textId)
        .attr('x', x)
        .attr('y', 50)
        .attr('fill', color)
        .attr('text-anchor', 'end')
        .attr('dy', '.35em')

    },
    /**
       * 生成节点名称标签
       * @param svg 当前画布
       * @param id  节点id
       * @author Hanger Zou
       */
    drawNameLabel(svg, id) {
      const nameLabelGroup = svg.select('.nameLabelGroup')
      nameLabelGroup.select('#nodeLabel-' + id).remove()
      const startNode = svg.select('#start-' + id)
      const x0 = startNode.attr('cx')
      nameLabelGroup.append('text')
        .text(this.dragNodeMap.get(id).label)
        .attr('id', 'nodeLabel-' + id)
        .attr('x', x0)
        .attr('y', 10)
        .attr('fill', '#9270CA')
        .attr('text-anchor', 'start')
        .attr('dy', '.35em')
    }

  }

}

</script>

<style lang="scss" scoped>
  ::v-deep svg {
    font-size: 8px;
  }
  .canvas {
    border: 1px solid darkcyan;
  }
  ::v-deep  .xaxis {
    border: 1px solid darkcyan;
  }
  /* 拓扑图--start */
  /* 节点状态颜色 */
  ::v-deep g.type-current>circle {
    fill: #FFAC27;
  }
  ::v-deep g.type-today>circle {
    fill: #e1e1e2;
  }
  ::v-deep g.type-flow>circle {
    fill: #67C23A;
  }
  ::v-deep g.type-end>circle {
    fill: #7f7ffd;
  }
  ::v-deep g.type-success>circle {
    fill: #9270CA;
  }

  ::v-deep g.type-fail>circle {
    fill: #67C23A;
  }

  ::v-deep g.type-done>circle {
    fill: #E8684A;
  }
  ::v-deep .activeNode>circle {
    fill: #f9e56d !important;
  }
  ::v-deep .unActiveNode>circle {
    fill: #e1e1e2 !important;
  }
  ::v-deep .activeCurentNode>circle {
    fill: #f9e56d !important;
  }
  ::v-deep circle.startNode {
    fill: #9270CA;
  }
  ::v-deep circle.endNode {
    fill: transparent;
    stroke:  #E8684A;
    stroke-width: 1;
  }
  ::v-deep foreignObject {
    width: 0.3rem;
    /*height: 55px;*/
    /*background-color: transparent;*/
  }
  ::v-deep b {

  }
  /* 拓扑图--end */
</style>

<style>
  .service b {
    /*position: relative;*/
    /*bottom: -40px;*/
    /*left: 50%;*/
    /*transform: translateX(-50%);*/
    /*font-style: normal;*/
  }
  /* 坐标轴-start */
  .axis path,
  .axis line {
    fill: none;
    stroke: #DCDCDC;
    shape-rendering: crispEdges;
  }

  .axis  text {
    font-family: sans-serif;
    font-size: 12px;
    fill: #999999;
  }

  .axis .x2-axis text {
    font-size: 14px;
    font-weight: 400;
    fill: #333;
  }

  .axis .x2-axis .tick {
    stroke-width: 2px;
  }
  .active {
    stroke-width: 2px;
    opacity: 1 !important;
    stroke: #e33b19 !important;
  }
  .active2 {
    stroke-width: 2px;
    opacity: 1 !important;
  }
  .tooltip {
    position: absolute;
    font-size: 12px;
    text-align: center;
    background-color: white;
    border-radius: 3px;
    box-shadow: rgb(174, 174, 174) 0px 0px 10px;
    cursor: pointer;
    display: inline-block;
    padding: 10px;
  }

  .tooltip>div {
    padding: 10px;
  }
</style>
